var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardLightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36703 14.1606C8.9154 14.5998 9.69517 14.5995 10.2432 14.16L16.9151 8.80883L17.1442 8.6261C17.8959 8.02641 17.8971 6.88424 17.1467 6.28295L10.2433 0.751543C9.69517 0.312317 8.91561 0.312317 8.36744 0.751543L1.45964 6.28653C0.71064 6.88667 0.710154 8.0261 1.45864 8.62689L1.68531 8.80883L8.36703 14.1606Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2315 16.8626C9.68339 17.3018 8.90397 17.3018 8.3558 16.8628L2.42302 12.1109C2.01159 11.7813 1.40975 11.854 1.0885 12.2719C0.771997 12.6836 0.848846 13.2739 1.26022 13.5909L8.38698 19.0826C8.92647 19.4983 9.67833 19.4984 10.2179 19.0828L17.3413 13.5958C17.7562 13.2762 17.8335 12.6808 17.514 12.2659C17.1901 11.8453 16.584 11.7725 16.1697 12.1045L10.2315 16.8626Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLightIcon);
export default __webpack_public_path__ + "static/media/dashboardLightIcon.049b5477fd9bf833bbea4a0f187e9c60.svg";
export { ForwardRef as ReactComponent };